import React, { Component } from 'react';
import {toast } from 'react-toastify';
import cookie from 'react-cookies';
import $ from 'jquery';
import {updateValueInJson, esUrl, showModalPageClass, hideModalPageClass} from '../../../../../functions';
import axios from 'axios';
import {API_URL} from '../../../../../constants';
import ModalMultimedia from '../../../../Partials/ModalMultimedia';

export default class AdmNoticiasHome extends Component {
    constructor(props) {
        super(props); 
        this.state = { 
            modulo: this.props.modulo,
            sectorLongitud:0,
            tituloLongitud:0,
            descripcionLongitud:0,
            imagenLongitud:0,
            enlaceLongitud:0,
            resource:{
                pmod_Id:0,
                pagi_Id:this.props.pagina,
                Mweb_Id:this.props.modulo.id,
                mnho_Sector:"",
                mnho_Titulo:"",
                mnho_Descripcion:"",
                mnho_Imagen:"",
                mnho_Enlace:"",
                mnho_Orden:0,
                mnho_Activo:true
            },
            resourceEdit:{
                mnho_Id:0,
                mnho_Sector:"",
                mnho_Titulo:"",
                mnho_Descripcion:"",
                mnho_Imagen:"",
                mnho_Enlace:"",
                mnho_Orden:0,
                mnho_Activo:true
            },
            Validacion: {
                mnho_Sector: {
                    Error: false,                    
                },
                mnho_Titulo: {
                    Error: false,                    
                },
                mnho_Descripcion: {
                    Error: false,                    
                },
                mnho_Imagen: {
                    Error: false,                    
                },
                mnho_Enlace: {
                    Error: false,                    
                },
                mnho_Orden: {
                    Error: false,                    
                }
            },
            ValidacionEdit:{
                mnho_Sector: {
                    Error: false,                    
                },
                mnho_Titulo: {
                    Error: false,                    
                },
                mnho_Descripcion: {
                    Error: false,                    
                },
                mnho_Imagen: {
                    Error: false,                    
                },
                mnho_Enlace: {
                    Error: false,                    
                },
                mnho_Orden: {
                    Error: false,                    
                }
            },
            noticias:[],
            hasError:false,
            added:false,
            confirmStore:false,
            security: cookie.load('user'),
            roles: [], 
            fieldReturnMultimedia:""
          }

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleInputChangeEdit = this.handleInputChangeEdit.bind(this);
        this.getResponseMultimedia = this.getResponseMultimedia.bind(this);
    }

    getResponseMultimedia = (urlSeleccionada) => {
        let resource = this.state.isEditfieldReturnMultimedia ? this.state.resourceEdit : this.state.resource;
        let fieldReturn = this.state.fieldReturnMultimedia;
    
        if(fieldReturn!== ""){
            resource[fieldReturn] = urlSeleccionada;
            
            if(this.state.isEditfieldReturnMultimedia){
                this.setState({resourceEdit:resource, fieldReturnMultimedia:"", isEditfieldReturnMultimedia:false});
            }else{
                this.setState({resource:resource, fieldReturnMultimedia:""});
            }
        }
    
        hideModalPageClass("divGestorArchivosNoticia");
    }
    
    showModalMultimedia = (clase = "", campo = "", isEdition = false) => {
        this.setState({fieldReturnMultimedia:campo, isEditfieldReturnMultimedia:isEdition});
        showModalPageClass(clase);
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let copyResource = this.state.resource;
        let sectorLongitud = this.state.sectorLongitud;
        let tituloLongitud = this.state.tituloLongitud;
        let descripcionLongitud = this.state.descripcionLongitud;
        let imagenLongitud = this.state.imagenLongitud;
        let enlaceLongitud = this.state.enlaceLongitud;
        let validaciones = this.state.Validacion;

        copyResource[target.name] = value;
        validaciones[target.name] = {
            Error: false,                    
        }

        if(target.name == 'mnho_Sector'){
            sectorLongitud = value.length;
        }
        if(target.name == 'mnho_Titulo'){
            tituloLongitud = value.length;
        }
        if(target.name == 'mnho_Descripcion'){
            descripcionLongitud = value.length;
        }
        if(target.name == 'mnho_Imagen'){
            imagenLongitud = value.length;
        }
        if(target.name == 'mnho_Enlace'){
            enlaceLongitud = value.length;
        }

        this.setState({
            resource: copyResource,
            sectorLongitud: sectorLongitud,
            tituloLongitud: tituloLongitud,
            descripcionLongitud: descripcionLongitud,
            imagenLongitud: imagenLongitud,
            enlaceLongitud: enlaceLongitud,
            Validacion: validaciones
        });  
    }

    handleInputChangeEdit(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let copyResource = this.state.resourceEdit;
        let sectorLongitud = this.state.sectorLongitud;
        let tituloLongitud = this.state.tituloLongitud;
        let descripcionLongitud = this.state.descripcionLongitud;
        let imagenLongitud = this.state.imagenLongitud;
        let enlaceLongitud = this.state.enlaceLongitud;
        let validaciones = this.state.ValidacionEdit;

        copyResource[target.name] = value;
        validaciones[target.name] = {
            Error: false,                    
        }

        if(target.name == 'mnho_Sector'){
            sectorLongitud = value.length;
        }
        if(target.name == 'mnho_Titulo'){
            tituloLongitud = value.length;
        }
        if(target.name == 'mnho_Descripcion'){
            descripcionLongitud = value.length;
        }
        if(target.name == 'mnho_Imagen'){
            imagenLongitud = value.length;
        }
        if(target.name == 'mnho_Enlace'){
            enlaceLongitud = value.length;
        }

        this.setState({
            resourceEdit: copyResource,
            sectorLongitud: sectorLongitud,
            tituloLongitud: tituloLongitud,
            descripcionLongitud: descripcionLongitud,
            imagenLongitud: imagenLongitud,
            enlaceLongitud: enlaceLongitud,
            ValidacionEdit: validaciones
        });  
    }

    showAgregarNoticia = (e) => {
        e.preventDefault();

        $(".containerFormCreationNoticia").fadeIn();  
        $("#btnGuardarNoticia").fadeIn();
        $("#btnAgregarNoticia").fadeOut();
    }

    hideAgregarNoticia = (e) => {
        if(e != undefined){
            e.preventDefault();
        }

        $(".containerFormCreationNoticia").fadeOut();  
        $("#btnGuardarNoticia").fadeOut();
        $("#btnAgregarNoticia").fadeIn();
    }

    checkedValidate = (item, isEdition = false) => {
        if(isEdition)
        {
            let resource = this.state.resourceEdit;
            resource[item] = !resource[item];
    
            this.setState({resourceEdit:resource});
        }else{
            let resource = this.state.resource;
            resource[item] = !resource[item];

            this.setState({resource:resource});
        }
    }

    storeNoticia = (e) => {
        if(e != undefined){
            e.preventDefault();
        }

        let newState = this.state;
        newState.hasError = false;

        if (newState.resource.mnho_Titulo == '') {  
            newState.Validacion.mnho_Titulo = {Error: true};
            newState.hasError = true;
        }

        if (newState.resource.mnho_Descripcion == '') {  
            newState.Validacion.mnho_Descripcion = {Error: true};
            newState.hasError = true;
        }

        if (newState.resource.mnho_Imagen == '') {  
            newState.Validacion.mnho_Imagen = {Error: true};
            newState.hasError = true;
        }

        if (newState.resource.mnho_Enlace == '') {  
            newState.Validacion.mnho_Enlace = {Error: true};
            newState.hasError = true;
        }

        if (newState.resource.mnho_Enlace !== '' && !esUrl(newState.resource.mnho_Enlace)) {  
            newState.Validacion.mnho_Enlace = {Error: true};
            newState.hasError = true;
        }

        if(newState.hasError){
            this.setState(newState);
            return;
        }

        const url = `${API_URL}ModuloNoticiaHomeUX/`;
        var dataForm = this.state.resource;
        dataForm = updateValueInJson(dataForm,'mnho_UsuarioCreacion', this.state.security.nUsuCodigo);

        const formData = JSON.stringify(dataForm);

        axios.post(
        url, 
        JSON.stringify(formData),
        { headers: {
                'Content-Type': 'application/json; charset=UTF-8' ,
                'Accept': 'application/json'
            }
        }
        ).then(
        (data)=> {             
            if (data.data.isSucess)
            {
                let result = data.data.result;
                let stateResponse = this.state;

                stateResponse.added = true;
                stateResponse.resource.mnho_Sector = '';
                stateResponse.resource.mnho_Titulo = '';
                stateResponse.resource.mnho_Descripcion = '';
                stateResponse.resource.mnho_Imagen = '';
                stateResponse.resource.mnho_Enlace = '';
                stateResponse.resource.mnho_Orden += 1;
                stateResponse.resource.pmod_Id = result.pmod_Id;

                this.setState(stateResponse);
                this.loadNoticias();
                setTimeout(() => { 
                    this.setState({added:false});
                }, 3000); 
                
                this.hideAgregarNoticia();

            
            } else 
            {
                this.setState({hasErrorProceso:true});

                setTimeout(() => { 
                    this.setState({hasErrorProceso:false});
                }, 3000); 
            }
        }
        ).catch((error)=> {
            console.log('Error no controlado.');
            this.setState({loading:false});
        });        
    }

    updateNoticia = (e) => {
        if(e != undefined){
            e.preventDefault();
        }

        let newState = this.state;
        newState.hasError = false;

        if (newState.resourceEdit.mnho_Titulo == '') {  
            newState.ValidacionEdit.mnho_Titulo = {Error: true};
            newState.hasError = true;
        }

        if (newState.resourceEdit.mnho_Descripcion == '') {  
            newState.ValidacionEdit.mnho_Descripcion = {Error: true};
            newState.hasError = true;
        }

        if (newState.resourceEdit.mnho_Imagen == '') {  
            newState.ValidacionEdit.mnho_Imagen = {Error: true};
            newState.hasError = true;
        }

        if (newState.resourceEdit.mnho_Enlace !== '' && !esUrl(newState.resourceEdit.mnho_Enlace)) {  
            newState.ValidacionEdit.mnho_Enlace = {Error: true};
            newState.hasError = true;
        }

        if(newState.hasError){
            this.setState(newState);
            return;
        }

        const url = `${API_URL}ModuloNoticiaHomeUX/`;
        var dataForm = this.state.resourceEdit;
        dataForm = updateValueInJson(dataForm,'mnho_UsuarioEdicion', this.state.security.nUsuCodigo);

        const formData = JSON.stringify(dataForm);

        axios.put(
        url, 
        JSON.stringify(formData),
        { headers: {
                'Content-Type': 'application/json; charset=UTF-8' ,
                'Accept': 'application/json'
            }
        }
        ).then(
        (data)=> {             
            if (data.data.isSucess)
            {
                this.setState({resourceEdit: {
                    mnho_Id:0,
                    mnho_Sector:"",
                    mnho_Titulo:"",
                    mnho_Descripcion:"",
                    mnho_Imagen:"",
                    mnho_Enlace:"",
                    mnho_Orden:0,
                    mnho_Activo:true
                }});
                this.loadNoticias();
            
            } else 
            {
                this.setState({hasErrorProceso:true});

                setTimeout(() => { 
                    this.setState({hasErrorProceso:false});
                }, 3000); 
            }
        }
        ).catch((error)=> {
            console.log('Error no controlado.');
            this.setState({loading:false});
        });        
    }

    loadNoticias = () => {
        let pmod_Id = this.state.resource.pmod_Id;

        const url = `${API_URL}ModuloNoticiaHomeUX/${pmod_Id}`;

        axios.get(url).then(response => response.data)
        .then((data) => {
            let resourceNoticia = this.state.resource;
            resourceNoticia.mnho_Orden = data.result.length + 1;
            this.setState({ noticias: data.result, resource: resourceNoticia});
        })
        .catch(error => {
            console.log('Error de comunicación');   
        });
    }

    actualizarEstado = (entity, e) => {
        e.preventDefault();

        const url = `${API_URL}ModuloNoticiaHomeUX/`;
        entity.mnho_Activo = !entity.mnho_Activo;
        
        let dataToSave = updateValueInJson(entity, 'mnho_UsuarioEdicion', this.state.security.nUsuCodigo);
        const formData = JSON.stringify(dataToSave);

        axios.put(
            url, 
            JSON.stringify(formData),
            { headers: {
                'Content-Type': 'application/json; charset=UTF-8' ,
                'Accept': 'application/json'
                }
            }
            ).then(
                (data)=> {     
                    if (data.data.isSucess)
                    {
                        this.loadNoticias();
                        return;
                    } else 
                    {                        
                        console.log('No se pudo procesar la solicitud \r');
                    }
                    this.setState({loading:false});
                }
            ).catch((error)=> {
                console.log('Error no controlado.');
                this.setState({loading:false});
            });  
    }

    eliminarRegistro = async(entity, e) => {
        e.preventDefault();

        const url = `${API_URL}ModuloNoticiaHomeUX/Eliminar`;
        let dataToSave=updateValueInJson(entity, 'mnho_UsuarioEliminacion', this.state.security.nUsuCodigo);
        const formData = JSON.stringify(dataToSave);

        await axios.put(
            url, 
            JSON.stringify(formData),
            { headers: {
                'Content-Type': 'application/json; charset=UTF-8' ,
                'Accept': 'application/json'
                }
            }
            ).then(
                (data)=> {     
                    if (data.data.isSucess)
                    {
                        this.loadNoticias();
                        return;
                    } else 
                    {
                        this.setState({loading:false});
                        console.log('No se pudo procesar la solicitud \r');
                    }
                }
            ).catch((error)=> {
                console.log('Error no controlado.');
                this.setState({loading:false});
            });  
    }

    editRegistro = (entity, e) => {
        e.preventDefault();
        let newEntity = entity;
        this.setState({resourceEdit: newEntity});
    }

    closeNoticia = () => {

        let resource = this.state.resource;
        resource.pmod_Id = 0;
        this.setState({resource:resource, noticias:[]});

        this.props.callback(true);
        
    }

    cancelarEdicionNoticia = () => {
        
        this.setState({
            resourceEdit:{
                mnho_Id:0,
                mnho_Sector:"",
                mnho_Titulo:"",
                mnho_Descripcion:"",
                mnho_Imagen:"",
                mnho_Enlace:"",
                mnho_Orden:0,
                mnho_Activo:true
            }
        });
    }

    componentWillReceiveProps(nextProps){
        let mweb = 72;

        if(nextProps.pmodId !== this.state.resource.pmod_Id && mweb == nextProps.mWebEdit){
            let resource = this.state.resource;
            resource.pmod_Id = nextProps.pmodId;

            this.setState({resource: resource});

            setTimeout(() => { 
                this.loadNoticias();
            }, 100); 
        }
    } 

    render() {
        let modulo = this.state.modulo;

        return (
            <div className="divModalBanner popUpGeneral" id={"modal_" + modulo.id} style={{display:"none"}}>
                <div className="divLayerPopup_ModalPaginas">
                    <div className="divPopup_ModalPaginas">
                    <div className="divClosePopup_Modals" onClick={() => this.closeNoticia()}/>
                    <h2>{modulo.nombre} </h2>
                    <div className="divWrapperModalPaginas">
                        {
                            this.state.noticias.length > 0 ?
                            <div className="divModuloPopup_Panel">
                                {
                                    this.state.noticias.map((noticia) => (
                                        <React.Fragment>
                                        <div className="txtFile x-1">
                                            <input type="text" readOnly placeholder="Submenu" value={noticia.mnho_Titulo}/>
                                            <div className="divBtnAccionesPopup_Panel">
                                                <a href="#" className={noticia.mnho_Activo ? "btnPageModuloVer noneEvent" : "btnPageModuloInactivo noneEvent"} onClick={(e) => this.actualizarEstado(noticia, e)}/>                       
                                                <a href="#" className="btnPageModuloEditar noneEvent" onClick={(e) => this.editRegistro(noticia, e)}/>
												<a href className="btnPageModuloEliminar aEliminarMenu2"/>
												<div className="c_divAlertaCapa">
													<div className="divAlertaCapa">
														<div className="divAlerta">
															<h2>&iquest;Seguro de eliminar?</h2>
															<div className="divAlertaBtn">
																<a href="#" className="btnAlertaAceptar" onClick={(event) => this.eliminarRegistro(noticia, event)}>ACEPTAR</a>
																<a href="#" className="btnAlertaCancelar">CANCELAR</a>
															</div>
														</div>
													</div>
												</div>
                                            </div>
                                        </div>
                                        {
                                            this.state.resourceEdit.mnho_Id == noticia.mnho_Id ?
                                            <div className="containerFormEdit divModuloPopup_Panel">
                                                {/* <div className="txtFile x-1">
                                                    <input type="text" placeholder="Categoría" name='mnho_Sector' value={this.state.resourceEdit.mnho_Sector} maxLength={50}   
                                                        onChange={this.handleInputChangeEdit} className={this.state.ValidacionEdit.mnho_Sector.Error ? "error" : ""}/>
                                                    <span data-length={30}>{this.state.sectorLongitud}/50</span>
                                                </div> */}
                                                <div className="txtFile x-1">
                                                    <input type="text" placeholder="Título" name='mnho_Titulo' value={this.state.resourceEdit.mnho_Titulo} maxLength={100} 
                                                        onChange={this.handleInputChangeEdit} className={this.state.ValidacionEdit.mnho_Titulo.Error ? "error" : ""}/>
                                                    <span data-length={30}>{this.state.tituloLongitud}/100</span>
                                                </div>
                                                <div className="txtFile x-1">
                                                    <input type="text" placeholder="Descripción" name='mnho_Descripcion' value={this.state.resourceEdit.mnho_Descripcion} maxLength={200}  
                                                    onChange={this.handleInputChangeEdit} className={this.state.ValidacionEdit.mnho_Descripcion.Error ? "error" : ""}/>
                                                    <span data-length={150}>{this.state.descripcionLongitud}/200</span>
                                                </div>
                                                <div className="txtFile x-1 relative">
                                                    <span className="subirImagen" data-id="txtIconoCategoria" onClick={() => this.showModalMultimedia("divGestorArchivosNoticia", "mnho_Imagen", true)}/>
                                                    <input type="text" placeholder="Imagen" name='mnho_Imagen' value={this.state.resourceEdit.mnho_Imagen} 
                                                        onChange={this.handleInputChangeEdit} className={this.state.ValidacionEdit.mnho_Imagen.Error ? "error" : ""}/>
													<label className="recomendacion">Se recomienda la dimensión de 508px de ancho X 249px de alto.</label>
                                                </div>
                                                <div className="txtFile x-1">
                                                    <input type="text" placeholder="Enlace" name='mnho_Enlace' value={this.state.resourceEdit.mnho_Enlace} 
                                                        onChange={this.handleInputChangeEdit}className={this.state.ValidacionEdit.mnho_Enlace.Error ? "error" : ""} />
                                                </div>
                                                <div className="txtFile x-2">
                                                    <input type="text" placeholder="Orden" name='mnho_Orden' value={this.state.resourceEdit.mnho_Orden} maxLength={2} 
                                                        onChange={this.handleInputChangeEdit} className={this.state.ValidacionEdit.mnho_Orden.Error ? "error" : ""}/>
                                                </div>
                                                <div className="clear"></div>
                                                <div className="txtFile x-2">
                                                    <a href="" className="btnAgregarPagina" id="btnActualizarBanner" onClick={(e) => this.updateNoticia(e)}>ACTUALIZAR</a>
                                                    <a href="" className="btnAgregarPagina noneEvent" id="btnCancelarActualizarBanner" onClick={() => this.cancelarEdicionNoticia()}>CANCELAR</a>
                                                </div>
                                            </div>
                                            : null
                                        }
                                        </React.Fragment>
                                    ))
                                }
                            </div> : null
                        }
                        <div className="containerFormCreationNoticia divModuloPopup_Panel" style={{display:"none"}}>
                            {/* <div className="txtFile x-1">
                                <input type="text" placeholder="Categoría" name='mnho_Sector' value={this.state.resource.mnho_Sector} maxLength={50}  
                                    onChange={this.handleInputChange} className={this.state.Validacion.mnho_Sector.Error ? "error" : ""} />
                                <span data-length={30}>{this.state.sectorLongitud}/50</span>
                            </div> */}
                            <div className="txtFile x-1">
                                <input type="text" placeholder="Título" name='mnho_Titulo' value={this.state.resource.mnho_Titulo} maxLength={100}  
                                    onChange={this.handleInputChange} className={this.state.Validacion.mnho_Titulo.Error ? "error" : ""}/>
                                <span data-length={30}>{this.state.tituloLongitud}/100</span>
                            </div>
                            <div className="txtFile x-1">
                                <input type="text" placeholder="Descripción" name='mnho_Descripcion' value={this.state.resource.mnho_Descripcion} maxLength={200}  
                                    onChange={this.handleInputChange} className={this.state.Validacion.mnho_Descripcion.Error ? "error" : ""}/>
                                <span data-length={150}>{this.state.descripcionLongitud}/200</span>
                            </div>
                            <div className="txtFile x-1 relative">
                                <span className="subirImagen" data-id="txtIconoCategoria" onClick={() => this.showModalMultimedia("divGestorArchivosNoticia", "mnho_Imagen")}/>
                                <input type="text" placeholder="Imagen" name='mnho_Imagen' value={this.state.resource.mnho_Imagen} 
                                onChange={this.handleInputChange} className={this.state.Validacion.mnho_Imagen.Error ? "error" : ""}/>
								<label className="recomendacion">Se recomienda la dimensión de 508px de ancho X 249px de alto.</label>
                            </div>
                            <div className="txtFile x-1">
                                <input type="text" placeholder="Enlace" name='mnho_Enlace' value={this.state.resource.mnho_Enlace} 
                                    onChange={this.handleInputChange} className={this.state.Validacion.mnho_Enlace.Error ? "error" : ""} />
                            </div>
                            <div className="txtFile x-2">
                                <input type="text" placeholder="Orden" name='mnho_Orden' value={this.state.resource.mnho_Orden} maxLength={2} 
                                    onChange={this.handleInputChange} className={this.state.Validacion.mnho_Orden.Error ? "error" : ""} />
                            </div>
                        </div>
                        <div>
                            <a href="" className="btnAgregarPagina" id="btnAgregarNoticia" onClick={(e) => this.showAgregarNoticia(e)}>AGREGAR</a>
                            <a href="" style={{display:"none"}} className="btnAgregarPagina" id="btnGuardarNoticia" onClick={(e) => this.storeNoticia(e)}>GUARDAR</a>
                            <br/>
                            <br/>
                            <br/>
                        </div>
                    </div>
                    </div>
                </div>
                <ModalMultimedia class="divGestorArchivosNoticia" callback={this.getResponseMultimedia.bind(this)}/>
            </div>
        )
    }
}